/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState_hawb = [
    {
        id: '',
        il_air_import_id: '',
        hawb: '',
        il_trade_partner_id_shipper: '',
        il_trade_partner_id_consignee: '',
        hawb_link: '',
        import_service_fee: 'Pending',
        import_service_fee_link: '',
        import_service_fee_date: null,
        pre_alert: '',
        arrival_notice: 'Waiting',
        arrival_notice_link: '',
        invoice: 'Pending',
        invoice_link: [],
        invoice_date: null,
        crdr: 'Pending',
        crdr_link: [],
        crdr_date: null,
    },
];

const aimHblUpdateSlice = createSlice({
    name: 'aimHblUpdateForm',
    initialState: initialState_hawb,
    reducers: {
        setHblFormData: (state, action) => {
            return action.payload;
        },
        setHblUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
        addHBL: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteHBL: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((hbl) => hbl.id !== idToDelete);
        },
    },
});

export const { setHblFormData, setHblUpdateData, addHBL, deleteHBL } = aimHblUpdateSlice.actions;
export default aimHblUpdateSlice.reducer;
